"use client";

import React, { useState } from 'react';
import Text from '@components/atoms/Text';
import Image from 'next/image';
import styles from './SeeHowRatingsWork.module.scss';
import { ourExpertsData, parameterConsideredData, carPriceRanges, ratingCriteriaData } from "./SeeHowRatingsWork.data";
import { useRouter } from 'next/navigation';
import assetLoader from '@utils/internalImageLoder';
import ImageResponsiveAssets from '@components/atoms/ImageResponsiveAssets';
import { EventType, trackEventWithCommonProps } from '@utils/eventTracker';
import { PAGE_TYPES } from '@constants/pageTypes';

const SeeHowRatingsWork = ({cityName, isInApp}: any) => {

    const router = useRouter();
    const [openAccordions, setOpenAccordions] = useState<number[]>([]);
    const [activePriceRange, setActivePriceRange] = useState<string | null>(carPriceRanges[0].value);

    const toggleAccordion = (index: number) => {
        setOpenAccordions(prev =>
            prev.includes(index)
                ? prev.filter(i => i !== index)
                : [...prev, index]
        );
    };
    const onClickActivePrice = async (value: string) => {
        await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
            pageType: PAGE_TYPES.RATINGS_CALCULATION,
            additionalProps: {
                action_type: "tap_btn",
                action_name: "tap_btn_rating_calculation_price_range",
                value: value,
                city_name: cityName
            },
        });
        setActivePriceRange(value);
    };

    return (
        <div className={styles.SeeHowRatingsWork}>
            {
                !isInApp &&
                <Image
                    src={`${assetLoader()}/icons/chevron-left.svg`}
                    alt='chevron-left back'
                    width={10}
                    height={10}
                    loading='lazy'
                    className={styles.backIcon}
                    onClick={() => router.back()}
                />
            }
            <Text level="h1" className={styles.heading}>How are our ratings calculated?</Text>

            <div className={styles.container}>
                <div className={styles.contentContainer}>
                    <div className={styles.ratingCalculationContainer}>
                        <div className={styles.carPriceRanges}>
                            {carPriceRanges.map((range, index) => (
                                <button
                                    key={index}
                                    className={`${styles.priceRangeButton} ${activePriceRange === range.value ? styles.active : ''}`}
                                    onClick={() => onClickActivePrice(range.value)}
                                >
                                    {range.label}
                                </button>
                            ))}
                        </div>
                        <Text className={styles.descriptionText}>
                            The points given to each model is dependent on how it looks and if any part of the design contributes to the
                            overall functionality
                        </Text>
                        <div className={styles.ratingTable}>
                            <div className={styles.tableHeader}>
                                <Text className={styles.tableHeaderText}>Criterion for Scoring</Text>
                                <Text className={styles.tableHeaderText}>Weightage</Text>
                            </div>
                            {(activePriceRange && ratingCriteriaData[activePriceRange]) ? (
                                ratingCriteriaData[activePriceRange].map((item, index) => (
                                    <div key={index} className={styles.tableRow}>
                                        <Text className={styles.tableCell}>{item.criterion}</Text>
                                        <Text className={styles.tableCell}>{item.weightage}</Text>
                                    </div>
                                ))
                            ) : (
                                <div>No data available for this price range.</div>
                            )}
                        </div>
                    </div>

                    <div className={styles.accordionContianer}>
                        <Text className={styles.accordionHeading} level="h2">What are the parameters considered?</Text>
                        <div className={styles.accordionInnerContianer}>
                            {parameterConsideredData?.map((item, index) => {
                                const isOpen = openAccordions.includes(index);

                                return (
                                    <div className={styles.accordionContent} key={index}>
                                        <div
                                            className={styles.accordionTitleContianer}
                                            onClick={() => toggleAccordion(index)}
                                        >
                                            <Text className={styles.accordionTitle}>{item.title}</Text>
                                            <Image
                                                src={`${assetLoader()}/icons/${isOpen ? 'Chevron_up_dark.svg' : 'Chevron_down_dark.svg'}`}
                                                alt='Chevron_down'
                                                width={22}
                                                height={22}
                                                loading='lazy'
                                                className={isOpen ? styles.rotateIcon : ''}
                                            />
                                        </div>
                                        {isOpen && (
                                            <Text className={styles.accordionDescp}>{item.description}</Text>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                <div className={styles.ourExpertsContainer}>
                    <Text className={styles.heading}>Who are our experts?</Text>
                    <div className={styles.ourExperts}>
                        {ourExpertsData?.map((item, index) => (
                            <div key={index} className={styles.ourExpertsContent}>
                                <ImageResponsiveAssets
                                    name={item.image}
                                    filePath="/images/ratings"
                                    alt='expertImage'
                                    fill
                                    loading='lazy'
                                    className={styles.ourExpertImage}
                                />
                                <div className={styles.ourExpertDetails}>
                                    <Text className={styles.ourExpertName}>{item.name}</Text>
                                    <Text className={styles.ourExperttext}>{item.designation}</Text>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeeHowRatingsWork;
